import React, { useState, useContext } from "react";
import "./component.css";
import "../App.css";
import { libraryUrl, saveState } from "./util";
import Link from "./Link";
import { State } from "../context/State";
import { Button } from "@material-ui/core";
import { DialogActions } from "@material-ui/core";
import { DialogTitle } from "@material-ui/core";
import { DialogContentText } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";

export function MobileWarning() {
  const { state, setState } = useContext(State);
  const isSmall = window.innerWidth < 700;
  const [modalOpen, setModalOpen] = useState(
    state.showMobileWarning && isSmall
  );
  return (
    <div>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>App Experience</DialogTitle>
        <DialogContent>
          <DialogContentText>
            While the mobile experience is being improved, we recommend using
            your mobile device horizontally or using a desktop.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setModalOpen(false);
              const newState = { ...state, showMobileWarning: false };
              setState(newState, () => {
                saveState(newState);
              });
            }}
            color="primary"
          >
            Dismiss
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
